import { Adapter as e } from "../../../../adapter.js";
import { TicketHistoryStatusModel as s } from "./ticketHistoryStatus.model.js";
class o extends e {
  adapt(t) {
    return new s({
      previousStatus: t.previous_status,
      timestamp: new Date(t.timestamp * 1e3),
      newStatus: t.new_status
    });
  }
  serialize(t) {
  }
}
export {
  o as TicketHistoryStatusAdapter
};
//# sourceMappingURL=ticketHistoryStatus.adapter.js.map
